import { Col, Form as BSForm, Row } from 'react-bootstrap';
import { FieldArray, useFormikContext } from 'formik';
import LinkButton from '../../../../ui-elements/signite-link-button/linkButton';
import ReactDatePicker from 'react-datepicker';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
export const CareerGapForm = ({ handleChange, values, errors, handleBlur, touched }) => {
  const { setFieldValue } = useFormikContext();
  return (
    <div className="signite-form">
      <FieldArray name="careerGaps">
        {({ remove, push }) => (
          <>
            {values.careerGaps &&
              values.careerGaps.length > 0 &&
              values.careerGaps.map((careerGap, index) => (
                <div key={index}>
                  <Row className="mb-3">
                    <BSForm.Group as={Col}>
                      <BSForm.Label>Start Date</BSForm.Label>
                      <ReactDatePicker
                        name={`careerGaps.${index}.startDate`}
                        maxDate={new Date()}
                        selected={careerGap.startDate ? new Date(careerGap.startDate) : null}
                        onChange={(val) => {
                          setFieldValue(`careerGaps.${index}.startDate`, val, true);
                        }}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(errors, touched, `careerGaps.${index}.startDate`)}`}
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                        autoComplete="off"
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `careerGaps.${index}.startDate`)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col}>
                      <BSForm.Label>End Date</BSForm.Label>
                      <ReactDatePicker
                        name={`careerGaps.${index}.endDate`}
                        maxDate={new Date()}
                        selected={careerGap.endDate ? new Date(careerGap.endDate) : null}
                        onChange={(val) => {
                          setFieldValue(`careerGaps.${index}.endDate`, val, true);
                        }}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(errors, touched, `careerGaps.${index}.endDate`)}`}
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                        autoComplete="off"
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `careerGaps.${index}.endDate`)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col}></BSForm.Group>
                  </Row>
                  <Row>
                    <BSForm.Group as={Col}>
                      <BSForm.Label>Reason(s)</BSForm.Label>
                      <BSForm.Control
                        type="text"
                        name={`careerGaps.${index}.reasons`}
                        value={_.get(values, `careerGaps.${index}.reasons`)}
                        onChange={handleChange}
                        className={`form-control ${getErrorClass(errors, touched, `careerGaps.${index}.reasons`)}`}
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `careerGaps.${index}.reasons`)}
                      </span>
                    </BSForm.Group>
                  </Row>
                  <Row>
                    <Col>
                      <LinkButton
                        label="Remove Career Gap"
                        onClick={() => remove(index)}
                        icon={faMinusCircle}
                      ></LinkButton>
                    </Col>
                  </Row>
                  <hr
                    style={{
                      marginTop: 32,
                      marginBottom: 32,
                    }}
                  />
                </div>
              ))}
            <Row>
              <Col>
                <LinkButton
                  label="Add Career Gap"
                  onClick={() =>
                    push({
                      startDate: '',
                      endDate: '',
                      description: '',
                    })
                  }
                ></LinkButton>
              </Col>
            </Row>
          </>
        )}
      </FieldArray>
    </div>
  );
};